import type React from "react";

export function imgFallback(
  e: React.SyntheticEvent<HTMLImageElement, Event>,
  placeholder?: string | null
) {
  const ph = typeof placeholder === "string" ? placeholder.trim() : "";
  const el = e.currentTarget;

  if (!ph) {
    el.style.display = "none";
    return;
  }

  if (el.src !== ph) el.src = ph;
  else el.style.display = "none";
}
